import API from '../../../api/endpoints'
import event from '../../../event'
import Vue from 'vue'
import service from './service'
export default {
  loadFormData ({state, commit, rootState, dispatch}, data) {
    dispatch('loadLocations')
    dispatch('loadAccounts')
    dispatch('loadBookers')
    dispatch('loadQuotes')
  },
  loadJobServiceTypes ({state, commit, rootState, dispatch}, data) {
    Vue.http.get(API.GET_ALL_SERVICE_TYPES)
      .then(({data}) => {
        if (data) {
          commit('UPDATE_ALL_SERVICES', data)
        } else {
          commit('UPDATE_ALL_SERVICES', [])
        }
      }).catch((err) => {
        event.$emit('toast', { message: err.message, type: 'warning' })
      })
  },
  metricsChange ({state, commit, rootState}, data) {
    commit('UPDATE_METRICS', data)
  },
  preferencesChange ({state, commit, rootState}, data) {
    commit('UPDATE_PREFERENCES', data)
  },
  sendRateRequest ({state, commit, rootState}, rateRequest) {
    return new Promise((resolve, reject) => {
      service.getRates(rateRequest)
        .then(res => {
          if (res.ok) {
            commit('SET_RATE', res.data)
            resolve(res.data)
          } else {
            reject(res.data.responseNotes || 'An error occurred; please try again or contact support.')
          }
        })
        .catch(err => {
          reject(err.bodyText || 'An error occurred; please try again or contact support.')
        })
    })
  },
  sendOriginAccessorialRequest ({state, commit, rootState}, accessorialaRequest, whichState) {
    return new Promise((resolve, reject) => {
      service.getAccessorials(accessorialaRequest)
        .then(res => {
          if (res.ok) {
            commit('SET_ORIGIN_ACCESSORIALS', res.data)
            resolve(res.data)
          } else {
            reject(res.data.responseNotes || 'An error occurred; please try again or contact support.')
          }
        })
        .catch(err => {
          reject(err.bodyText || 'An error occurred; please try again or contact support.')
        })
    })
  },
  sendDestinationAccessorialRequest ({state, commit, rootState}, accessorialaRequest, whichState) {
    return new Promise((resolve, reject) => {
      service.getAccessorials(accessorialaRequest)
        .then(res => {
          if (res.ok) {
            commit('SET_DESTINATION_ACCESSORIALS', res.data)
            resolve(res.data)
          } else {
            reject(res.data.responseNotes || 'An error occurred; please try again or contact support.')
          }
        })
        .catch(err => {
          reject(err.bodyText || 'An error occurred; please try again or contact support.')
        })
    })
  },
  getMultiRates (a, arr) {
    return service.getRatesMulti(arr)
  },
  sendSpecialWorkbenchRequest ({state, commit, rootState}, specialRateWorkbenchRequest) {
    console.log(specialRateWorkbenchRequest)
    return service.getRates(specialRateWorkbenchRequest)
  },
  sendMaiRequest ({state, commit, rootState}, rateRequest) {
    return new Promise((resolve, reject) => {
      service.getMaiRates(rateRequest)
        .then(res => {
          if (res.ok) {
            commit('SET_RATE', res.data)
            resolve(res.data)
          } else {
            reject(res.data.responseNotes || 'An error occurred; please try again or contact support.')
          }
        })
        .catch(err => reject(err.bodyText.responseNotes || err.bodyText || 'An error occurred; please try again or contact support.'))
    })
  },
  sendGraphRequest ({state, commit, rootState}, rateRequest) {
    return new Promise((resolve, reject) => {
      service.getGraph(rateRequest)
        .then(res => {
          if (res.ok) {
            commit('SET_GRAPH', res.data)
            resolve(res.data)
          } else {
            reject(res.data.responseNotes || 'An error occurred; please try again or contact support.')
          }
        })
        .catch(err => {
          reject(err.statusText || 'An error occurred; please try again or contact support.')
        })
    })
  },
  sendWorkbenchRequest ({state, commit, rootState}, req) {
    return service.getWorkbench(req)
  },
  mapLocationsWithCountry ({state, commit, rootState}, locations) {
    return new Promise((resolve, reject) => {
      const countries = rootState.systemOption.countries
      if (countries.length) {
        resolve(locations.map(item => {
          const country = countries.find(({id}) => item.country !== null && id === item.country.id)
          item.country = country || item.country
          return item
        }))
      } else {
        reject('No countries loaded')
      }
    })
  },
  getProviders ({state, dispatch, commit, rootState}, providersArray) {
    service.getParties(providersArray).then(({data}) => commit('SET_PROVIDERS', data))
    .catch(err => console.log(err))
  },
  addProviders ({state, dispatch, commit, rootState}, providersArray) {
    service.getParties(providersArray).then(({data}) => commit('ADD_PROVIDERS', data))
    .catch(err => console.log(err))
  },
  getAvailableJobTypes (context, json) {
    return service.getJobTypes(json)
  },
  getFinanceItems ({ state, dispatch, commit, rootState }, { financeProfileId, baseCurrencyCode }) {
    if (!financeProfileId) {
      service.getFinanceProfile({ code: 'DEFAULT_CHARGE_PROFILE' })
      .then(({data}) => {
        if (data.length > 0) {
          dispatch('loadFinanceItems', { financeProfileId: data[0].id, baseCurrencyCode })
        }
      }).catch(err => console.log(err))
    } else {
      dispatch('loadFinanceItems', { financeProfileId, baseCurrencyCode })
    }
  },
  loadFinanceItems ({ state, dispatch, commit, rootState }, { financeProfileId, baseCurrencyCode }) {
    service.getFinancialProfileItems({ financeProfileId, baseCurrencyCode })
    .then(({data}) => {
      commit('SET_FINANCE_ITEMS', data)
    })
    .catch(err => {
      console.log(err)
      commit('SET_FINANCE_ITEMS', [])
    })
  },
  saveJob ({ state, dispatch, commit, rootState }, req) {
    return service.saveJob(req)
  }
}



// WEBPACK FOOTER //
// ./src/modules/quote/store/actions.js